(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
(() => {
  const labels = {
    de: ['Dein Name','Deine E-Mail-Adresse','Telefonnummer','Bestellnummer','Land','Deine Nachricht','Nachricht senden'],
    en: ['Your name','Your email address','Phone number','Order number','Country','Your message','Send message'],
    fr: ['Ton nom','Ton adresse e-mail','Numéro de téléphone','Numéro de commande','Pays','Ton message','Envoyer le message'],
    it: ['Il tuo nome','La tua e-mail','Numero di telefono','Numero ordine','Paese','Il tuo messaggio','Invia messaggio'],
    es: ['Tu nombre','Tu correo electrónico','Teléfono','Número de pedido','País','Tu mensaje','Enviar mensaje'],
    pl: ['Twoje imię','Twój adres e-mail','Numer telefonu','Numer zamówienia','Kraj','Twoja wiadomość','Wyślij wiadomość'],
    sv: ['Ditt namn','Din e-postadress','Telefonnummer','Ordernummer','Land','Ditt meddelande','Skicka meddelande'],
    fi: ['Nimesi','Sähköpostiosoitteesi','Puhelinnumero','Tilausnumero','Maa','Viestisi','Lähetä viesti'],
    nl: ['Je naam','Je e-mailadres','Telefoonnummer','Bestelnummer','Land','Je bericht','Bericht verzenden'],
    el: ['Το όνομά σου','Το email σου','Αριθμός τηλεφώνου','Αριθμός παραγγελίας','Χώρα','Το μήνυμά σου','Αποστολή μηνύματος']
  };
  const c = labels[(document.documentElement.lang || 'de').split('-')[0]] || labels.en;
  const update = () => document.querySelectorAll('.contact-form form[action*="/contact"]').forEach(form => {
    const selectors = ['.form-field--name input','.form-field--email input','.form-field--phone input','input[name="contact[Order Number]"]','select[name="contact[Country]"]','.form-field--body textarea'];
    selectors.forEach((selector,i) => {
      const field = form.querySelector(selector);if(!field)return;
      const label = field.closest('.form-field')?.querySelector('label');
      if(label){const mark=label.querySelector('span[aria-hidden="true"]')?.cloneNode(true);label.replaceChildren(document.createTextNode(c[i]+' '));if(mark)label.append(mark);}
      if(field.tagName==='SELECT'){const empty=field.querySelector('option[value=""]');if(empty)empty.textContent=c[i];}
      else field.placeholder=c[i];
    });
    const send=form.querySelector('button[type="submit"]');if(send)send.textContent=c[6];
  });
  update();document.addEventListener('shopify:section:load',update);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["farb-finder"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (scope) => {
    const picked = new Set((new URLSearchParams(location.search).get('advisor_colors') || '').split(',').filter(value => /^(13|11|12|10|9|2|4|7)$/.test(value)).slice(0, 2));
    scope.querySelectorAll('.monolith-farb-finder__form').forEach(form => {
      if (form.dataset.finderReady) return;
      form.dataset.finderReady = 'true';
      form.querySelectorAll('input[type="checkbox"]').forEach(input => {
        if (picked.has(input.value.split('/').pop())) input.checked = true;
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["monolith-shipping-bar"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('monolith-freeship-bar')) {
  class MonolithShippingBar extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.config = JSON.parse(this.querySelector('[data-shipping-config]').textContent);
      this.message = this.querySelector('.monolith-freeship__message');
      this.track = this.querySelector('.monolith-freeship__track');
      this.region = this.querySelector('[data-shipping-region]');
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.state = { total_price: this.config.total, currency: this.config.currency, requires_shipping: this.config.requiresShipping };
      this.storageKey = 'monolith-freeship-close:' + this.config.country + ':' + this.config.locale;
      try {
        if (!window.Shopify?.designMode && sessionStorage.getItem(this.storageKey) === '1') this.hidden = true;
        if (this.region) this.region.value = sessionStorage.getItem('monolith-freeship-region:ES') || '';
      } catch (_) {}
      this.querySelector('.monolith-freeship__close').addEventListener('click', () => {
        this.hidden = true;
        try { sessionStorage.setItem(this.storageKey, '1'); } catch (_) {}
      }, options);
      this.region?.addEventListener('change', () => {
        try { sessionStorage.setItem('monolith-freeship-region:ES', this.region.value); } catch (_) {}
        this.render();
      }, options);
      this.refreshSoon = () => {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.refresh(), 150);
      };
      ['cart:updated', 'cart:refresh', 'cart:change', 'cart:added'].forEach(name => document.addEventListener(name, this.refreshSoon, options));
      window.addEventListener('pageshow', this.refreshSoon, options);
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') this.refreshSoon();
      }, options);
      if (window.PerformanceObserver) {
        this.observer = new PerformanceObserver(list => {
          if (list.getEntries().some(entry => {
            const url = new URL(entry.name, location.origin);
            return url.origin === location.origin && /\/cart\/(add|change|update|clear)(\.js)?\/?$/.test(url.pathname);
          })) this.refreshSoon();
        });
        try { this.observer.observe({ type: 'resource', buffered: false }); } catch (_) {}
      }
      this.render();
      this.refresh();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      clearTimeout(this.timer);
      this.initialized = false;
      this.requestVersion = (this.requestVersion || 0) + 1;
    }
    async refresh() {
      const version = this.requestVersion = (this.requestVersion || 0) + 1;
      try {
        const response = await fetch(this.config.root.replace(/\/?$/, '/') + 'cart.js', { credentials: 'same-origin', cache: 'no-store', signal: this.controller.signal });
        if (!response.ok) throw new Error('Cart unavailable');
        const cart = await response.json();
        if (!this.isConnected || version !== this.requestVersion) return;
        this.state = cart;
        this.render();
      } catch (_) {
        if (this.isConnected && version === this.requestVersion) {
          this.state = null;
          this.render();
        }
      }
    }
    format(amount, currency) {
      return new Intl.NumberFormat(this.config.locale, { style: 'currency', currency, currencyDisplay: currency === 'EUR' ? 'symbol' : 'code', minimumFractionDigits: amount % 100 ? 2 : 0 }).format(amount / 100);
    }
    setMessage(template, amount, suffix = '') {
      if (!amount) {
        this.message.textContent = template;
        return;
      }
      const [before, after = ''] = template.split('[amount]');
      const strong = document.createElement('strong');
      strong.textContent = amount;
      this.message.replaceChildren(document.createTextNode(before), strong, document.createTextNode(after + suffix));
    }
    render() {
      const config = this.config;
      const labels = config.labels;
      const key = this.region ? this.region.value : config.country;
      const rate = config.rates[key];
      this.track.hidden = true;
      if (this.region && !key) {
        const base = config.rates.ES;
        const canary = config.rates['ES-CANARY'];
        this.setMessage(labels.intro, this.format(base.amount, base.currency), ' · ' + labels.canary + ': ' + this.format(canary.amount, canary.currency));
        return;
      }
      if (!rate) {
        this.message.textContent = labels.details;
        return;
      }
      const cart = this.state;
      const sameCurrency = cart && cart.currency === rate.currency;
      if (!sameCurrency || !cart.requires_shipping || !Number.isFinite(cart.total_price) || cart.total_price <= 0) {
        this.setMessage(labels.intro, this.format(rate.amount, rate.currency));
        return;
      }
      const remaining = Math.max(0, rate.amount - cart.total_price);
      if (remaining > 0) this.setMessage(labels.remaining, this.format(remaining, rate.currency));
      else this.setMessage(labels.reached);
      this.track.hidden = false;
      this.style.setProperty('--shipping-progress', Math.min(100, Math.max(0, cart.total_price / rate.amount * 100)) + '%');
    }
  }
  customElements.define('monolith-freeship-bar', MonolithShippingBar);
}


  } catch(e) { console.error(e); }
})();
})();
